<template>
  <v-dialog
    v-model="openDialogExisteInscripcion"
    max-width="480"
    persistent
    content-class="estado-inscripcion-dialog"
  >
    <v-card class="overflow-hidden">
      <!-- Header con ícono y título según estado -->
      <v-card-title class="pa-4 pb-2 headline" :class="headerClass">
        <v-icon large left class="mr-2">{{ headerIcon }}</v-icon>
        {{ headerTitle }}
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-4 pt-3">
        <p class="body-1 mb-4 grey--text text--darken-1" v-if="mensajeCorto">
          {{ mensajeCorto }}
        </p>

        <!-- Evento con pago online: solo invitar a volver a inscribirse -->
        <div v-if="usaPagoOnline" class="mb-4">
          <v-card flat class="pa-3 blue-grey lighten-5" style="border: 1px solid rgba(96, 125, 139, 0.4); border-radius: 8px;">
            <p class="body-2 mb-3 grey--text text--darken-2">
              Para inscribirte en este evento con pago online, completá el formulario nuevamente.
            </p>
            <v-btn
              color="primary"
              block
              @click="volverAInscribirme"
            >
              <v-icon left small>edit</v-icon>
              Volver a inscribirme
            </v-btn>
          </v-card>
        </div>

        <!-- Sin pago online: Pendiente = link a comprobante -->
        <div v-else-if="esPendiente" class="mb-4">
          <v-card flat class="pa-3 orange lighten-5" style="border: 1px solid rgba(255, 152, 0, 0.4); border-radius: 8px;">
            <p class="body-2 mb-3 grey--text text--darken-2">
              Completá el pago para confirmar tu inscripción.
            </p>
            <template v-if="comprobanteAccessToken">
              <p class="body-2 mb-3 grey--text text--darken-2">
                Si pagaste por transferencia o depósito, subí el comprobante para que podamos acreditar tu pago.
              </p>
              <v-btn
                block
                color="orange darken-2"
                dark
                :to="'/comprobante/' + comprobanteAccessToken"
              >
                <v-icon left small>cloud_upload</v-icon>
                Subir comprobante de pago
              </v-btn>
            </template>
            <template v-else>
              <p class="body-2 grey--text text--darken-2">
                {{ mensajeCorto || 'Tenés una inscripción pendiente.' }}
              </p>
            </template>
          </v-card>
        </div>

        <!-- Sin pago online: Expirada = reactivar -->
        <div v-else-if="esExpirada" class="mt-3">
          <v-card flat class="pa-3 red lighten-5" style="border: 1px solid rgba(244, 67, 54, 0.4); border-radius: 8px;">
            <p class="body-2 mb-3 grey--text text--darken-2">
              Podés reutilizar tu inscripción: te llevaremos a subir el comprobante o a completar el pago, según corresponda.
            </p>
            <v-btn
              color="red darken-2"
              block
              dark
              @click="volverAInscribirme"
            >
              <v-icon left small>refresh</v-icon>
              Volver a inscribirme
            </v-btn>
          </v-card>
        </div>

        <!-- Confirmada (pagada/bonificada): solo mensaje -->
        <div v-else-if="esConfirmada" class="mb-2">
          <p class="body-2 grey--text text--darken-2">
            Tu inscripción ya está confirmada. No tenés que hacer nada más.
          </p>
        </div>

        <!-- Otro estado: solo el mensaje según estado -->
        <div v-else class="mb-2">
          <p class="body-2 grey--text text--darken-2" v-if="existe_inscripcion_msg">
            {{ existe_inscripcion_msg }}
          </p>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 pt-3">
        <v-spacer />
        <v-btn flat color="grey darken-1" @click="closeDialog">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EstadoInscripcionDialog',
  props: {
    openDialogExisteInscripcion: {
      type: Boolean,
      default: false
    },
    existe_inscripcion_msg: {
      type: String,
      default: ''
    },
    inscripcion_state: {
      type: String,
      default: ''
    },
    mercadoPagoInitPoint: {
      type: String,
      default: null
    },
    comprobanteAccessToken: {
      type: String,
      default: null
    },
    usaPagoOnline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerClass() {
      if (this.usaPagoOnline) return 'blue-grey lighten-4';
      if (this.esConfirmada) return 'green lighten-4';
      if (this.esExpirada) return 'red lighten-4';
      if (this.esPendiente) return 'orange lighten-4';
      return 'grey lighten-3';
    },
    headerIcon() {
      if (this.usaPagoOnline) return 'info';
      if (this.esConfirmada) return 'check_circle';
      if (this.esExpirada) return 'schedule';
      if (this.esPendiente) return 'payment';
      return 'info';
    },
    headerTitle() {
      if (this.usaPagoOnline) return 'Inscripción existente';
      if (this.esConfirmada) return 'Inscripción confirmada';
      if (this.esExpirada) return 'Inscripción vencida';
      if (this.esPendiente) return 'Pago pendiente';
      return 'Estado de inscripción';
    },
    mensajeCorto() {
      if (this.usaPagoOnline) return 'Ya tenés una inscripción para este evento.';
      if (this.esConfirmada) return null;
      if (this.esExpirada) return 'Tu inscripción a este evento había expirado.';
      if (this.esPendiente) return 'Tenés una inscripción pendiente de pago.';
      return this.existe_inscripcion_msg || null;
    },
    esPendiente() {
      return this.inscripcion_state === 'pago_pendiente';
    },
    esExpirada() {
      return this.inscripcion_state === 'pago_expirado';
    },
    esConfirmada() {
      return this.inscripcion_state === 'pago_realizado' || this.inscripcion_state === 'pago_bonificado';
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialogExisteInscripcion');
    },
    volverAInscribirme() {
      this.$emit('volverAInscribirme');
    }
  }
};
</script>

<style scoped>
.estado-inscripcion-dialog >>> .v-card__title {
  word-break: normal;
}
</style>
